import { render, staticRenderFns } from "./StorageBrowserTable.vue?vue&type=template&id=1754b2b8&scoped=true&"
import script from "./StorageBrowserTable.vue?vue&type=script&lang=ts&"
export * from "./StorageBrowserTable.vue?vue&type=script&lang=ts&"
import style0 from "./StorageBrowserTable.vue?vue&type=style&index=0&id=1754b2b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1754b2b8",
  null
  
)

export default component.exports